declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, GridData, GridRow, AutoGenBase, AutoGenGrid } from '../../../../../models/actor/actor';
import { NgbFsEditGridRowModal } from '../../../../../../../../src/app/ncs/modules/testnurse/profile/patientprofileview/medicalrecord/modal/fseditgridrow.modal';
//import { NgbFsEditGridRowModal } from '../modal/fseditgridrow';
//import { NgbFsEditGridRowModal } from '../../../../../../../../../../../../../../../../../../../../../modal/fseditgridrow.modal';


@Component({
    selector: 'auto-gen-gridpv',
    templateUrl: './autogengridpv.component.html',
    styleUrls: ['./autogengridpv.component.scss']
})

export class AutoGenGridPVComponent implements OnInit {
    @Input() public mode;
    @Input() TemplateName: string;
    @Input() Date: Date;
    @Input() TitleName: string;

    @Input()
    public FormMode: string = 'Edit';
    @Input() public field: AutoGenGrid;//GridData;
    public fieldx: GridData;
    ngOnInit(): void {
        var x = this.field as AutoGenGrid;
        this.fieldx = x.Data as GridData;

    }

  constructor(private modalService: NgbModal) { }
  getCellTitle(CellIndex:number): string{
    var t: string = '';
    alert(CellIndex);
    t = this.fieldx.Columns[CellIndex].Title;


    return t;
  }
    Add() {
        
        //alert("Row Count: "  + this.field.Rows.length);
        //alert(this.field + this.field.ValueType);
        var modelRow: GridRow = new GridRow();
        modelRow.Cells = new Array<FieldData>();
        for (let col of this.fieldx.Columns) {
          //  alert(col.Data.Title);
            var modelCell = new FieldData();
            modelCell = new FieldData();
            modelCell.DataKey = 0;
            modelCell.ValueType = col.ValueType;
            modelCell.ValueSource = col.ValueSource;
            modelCell.TemplateItemCode = col.TemplateItemCode;
            modelCell.RootCOde = col.RootCOde;
            modelCell.ParentCode = col.ParentCode;
            modelCell.HasUnit = col.HasUnit;
            modelCell.Title = col.Title;
            modelCell.Unit = col.Unit;
            modelCell.Units = col.Units;
            modelCell.Unitsdata = col.Unitsdata;
         //   modelCell.Data.RowIndex = this.field.Rows.length;
            modelCell.RowIndex = this.field.Rows.length;
            modelRow.Cells.push(modelCell);
        }

        if (this.fieldx.Rows == null) {
            this.fieldx.Rows = new Array<GridRow>();
        }
        this.fieldx.Rows.push(modelRow);
     // as unknown as GridRow);

        const modalRef = this.modalService.open(NgbFsEditGridRowModal,
            {
                centered: true,
                size: "xl",                

            })
        modalRef.componentInstance.Mode = "Add";
        modalRef.componentInstance.GridRow = modelRow;
        modalRef.componentInstance.TemplateName = this.TemplateName;
        modalRef.componentInstance.Date = this.Date;
        modalRef.componentInstance.Title = this.fieldx.Title;
        modalRef.componentInstance.TitleName = this.TitleName;

        

        if (modalRef.result != null) {
            var mr = modalRef.result as unknown as string;

            if (mr == 'Close Click') {


            }
            else {
              
            }

        }

    }
    edit_row(row: GridRow) {
        // modaL OPEN
        const modalRef = this.modalService.open(NgbFsEditGridRowModal,
            {
                centered: true,
                size: "xl"

            })
        modalRef.componentInstance.Mode = "Edit";
        modalRef.componentInstance.GridRow = row;
        modalRef.componentInstance.TemplateName = this.TemplateName;
        modalRef.componentInstance.Date = this.Date;
        modalRef.componentInstance.Title = this.fieldx.Title;
        modalRef.componentInstance.TitleName = this.TitleName;


    }
}
